import {
  Box,
  Divider,
  Flex,
  Heading,
  Link,
  Spacer,
} from '@chakra-ui/react'
import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../../ui-kit'

const SideBarWrapper = styled(Box)`
  width: 100%;
  height: 100vh;
  background-color: ${colors.appPaleGrey};
  display: flex;
  flex-direction: column;
`

const SideBarHeading = styled(Flex)`
  padding: 1.5rem 0.75rem;
  flex-direction: row;
  min-height: calc(3rem + 2.5 * var(--chakra-fontSizes-xl));
  max-height: calc(3rem + 2.5 * var(--chakra-fontSizes-xl));
  align-items: center;
  border-bottom: 1px solid ${colors.appPaleLilac};
`

const SideBar = ({
  heading,
  subheading,
  button,
  children,
}: {
  heading: string
  subheading?: string
  button?: React.ReactElement
  children: React.ReactElement | React.ReactElement[] | null
}): React.ReactElement => (
  <SideBarWrapper>
    <SideBarHeading>
      <Heading as="h1" size="md" fontWeight="600" color={colors.appDarkIndigo}>
        {heading}
      </Heading>
      {subheading ? (
        <Heading
          as="h6"
          size="md"
          fontWeight="400"
          color={colors.appBattleshipGrey}
          marginLeft={1}
          fontSize="var(--chakra-fontSizes-md)"
        >
          {subheading}
        </Heading>
      ) : null}
      <Spacer />
      {button ?? null}
    </SideBarHeading>
    {children}
  </SideBarWrapper>
)

export default SideBar

export const SideBarItem = ({
  to,
  children,
  activeClassName,
}: {
  to: string
  activeClassName?: string | undefined
  children: React.ReactElement | React.ReactElement[]
}): React.ReactElement => (
  <Link
    as={NavLink}
    width="100%"
    to={to}
    _hover={{ textDecoration: 'none', outline: 'none' }}
    _focus={{ textDecoration: 'none', outline: 'none' }}
    _active={{ textDecoration: 'none', outline: 'none' }}
    outline="none"
    activeClassName={activeClassName}
    activeStyle={{
      background: colors.appPaleGreyThree,
      borderColor: '#e1e4eb',
    }}
    border="1px solid transparent"
    display="flex"
    flexDirection="row"
    justifyContent="flex-start"
    // exact
    position="relative"
  >
    {children}
  </Link>
)
